import React from 'react';
import { Nav, Offcanvas } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import {
  Speedometer2,
  Key,
  HddNetwork,
  Bookmark,
  ListCheck,
  Gear,
  Hash,
  Clock,
  Bell,
  X,
  Shield
} from 'react-bootstrap-icons';

const MobileSidebar = ({ visible, onHide }) => {
  const location = useLocation();
  
  // Get user data from localStorage for permissions
  const userData = JSON.parse(localStorage.getItem('user') || '{}');
  
  const mainNavItems = [
    { name: 'Dashboard', href: '/', icon: Speedometer2 },
    { name: 'Tokens', href: '/tokens', icon: Key },
    { name: 'Proxies', href: '/proxies', icon: HddNetwork },
    { name: 'Channels', href: '/channels', icon: Hash },
    { name: 'Queue', href: '/queue', icon: Clock },
    { name: 'Rules', href: '/rules', icon: Bookmark },
    { name: 'Logs', href: '/logs', icon: ListCheck },
    { name: 'Notifications', href: '/notifications', icon: Bell },
    { name: 'Settings', href: '/settings', icon: Gear },
  ];

  const adminNavItem = { name: 'Admin Panel', href: '/admin', icon: Shield, adminOnly: true };

  return (
    <Offcanvas show={visible} onHide={onHide} className="d-lg-none" style={{ width: '250px' }}>
      <Offcanvas.Header className="border-bottom p-3">
        <div className="d-flex align-items-center w-100">
          <h5 className="fw-bold text-primary mb-0 d-flex align-items-center">
            <HddNetwork className="me-2" size={24} />
            Discord Reactor
          </h5>
          <button 
            type="button" 
            className="btn-close ms-auto" 
            onClick={onHide}
            aria-label="Close"
          ></button>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0 d-flex flex-column">
        <Nav className="flex-column p-3">
          {/* Main Navigation Items */}
          {mainNavItems.map((item, index) => {
            // Check permissions for admin-only pages
            if (item.href === '/settings' && !userData.is_admin) {
              return null;
            }
            
            return (
              <Nav.Item key={index} className="mb-1">
                <Nav.Link
                  as={Link}
                  to={item.href}
                  onClick={onHide}
                  className={`d-flex align-items-center rounded px-3 py-2 text-decoration-none transition-all ${
                    location.pathname === item.href 
                      ? 'bg-primary text-white shadow-sm' 
                      : 'text-dark hover-bg-light'
                  }`}
                  style={{ 
                    transition: 'all 0.2s ease-in-out',
                    border: 'none'
                  }}
                >
                  <item.icon className="me-3" size={18} />
                  <span className="fw-medium">{item.name}</span>
                </Nav.Link>
              </Nav.Item>
            );
          })}

          {userData.is_admin && (
            <>
              <div className="border-top my-2"></div>
              
              {/* Admin Panel */}
              <Nav.Item className="mb-1">
                <Nav.Link
                  as={Link}
                  to={adminNavItem.href}
                  onClick={onHide}
                  className={`d-flex align-items-center rounded px-3 py-2 text-decoration-none transition-all ${
                    location.pathname === adminNavItem.href 
                      ? 'bg-warning text-dark shadow-sm' 
                      : 'text-dark hover-bg-light'
                  }`}
                  style={{ 
                    transition: 'all 0.2s ease-in-out',
                    border: 'none'
                  }}
                >
                  <adminNavItem.icon className="me-3" size={18} />
                  <span className="fw-medium">{adminNavItem.name}</span>
                </Nav.Link>
              </Nav.Item>

            </>
          )}
        </Nav>
        
        {/* System Status */}
        <div className="mt-auto p-3 border-top">
          <div className="d-flex align-items-center text-success">
            <div className="bg-success rounded-circle me-2" style={{ width: '8px', height: '8px' }}></div>
            <small className="fw-medium">System Online</small>
          </div>
          <small className="text-muted">Last updated: just now</small>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MobileSidebar;